/* eslint-disable no-param-reassign */
import { createAsyncThunk } from '@reduxjs/toolkit';

import { setSelectedProductChannel } from './setSelectedProductChannel';
import { removeListing, removeListingVariant } from './helpers/entityAdapter';
import pruneDeletedListingRows, {
  parseDeleteVariantResult,
} from './helpers/pruneDeletedListingRows';
import restoreMasterSelectionIfSoleDraftRemoved, {
  readSoleSelectionEntry,
} from './helpers/restoreMasterSelectionIfSoleDraftRemoved';

export const removeVariantFromChannel = createAsyncThunk(
  'products/removeVariantFromChannel',
  async ({ masterProductId, channelId, listingVariantId }, { dispatch, extra: { sdk, Logger } }) => {
    try {
      const response = await sdk.products.deleteVariant(listingVariantId);
      dispatch(setSelectedProductChannel({ productId: masterProductId, channelId: 'master' }));
      return {
        masterProductId,
        channelId,
        listingVariantId,
        ...parseDeleteVariantResult(response?.data, listingVariantId),
      };
    } catch (error) {
      Logger.error(new Error('Error removing variant from channel'), { error }, [
        'RemoveVariantFromChannelFailed',
        { errorMessage: 'Cannot remove variant from channel' },
      ]);
      throw error;
    }
  },
);

export const reducer = (builder) => {
  builder
    .addCase(removeVariantFromChannel.pending, (state) => {
      state.isBusy = true;
      state.error = null;
    })
    .addCase(removeVariantFromChannel.fulfilled, (state, { payload }) => {
      const {
        listingVariantId,
        deletedVariantIds = [listingVariantId],
        wipedListingIds = [],
      } = payload;
      state.isBusy = false;
      deletedVariantIds.forEach((variantId) => {
        removeListingVariant(state, variantId);
      });
      wipedListingIds.forEach((listingId) => {
        removeListing(state, listingId);
      });
      const soleEntry = readSoleSelectionEntry(state.ui?.selection);
      const selectionSource = state.ui?.selection?.source ?? null;
      pruneDeletedListingRows(state, {
        listingIds: wipedListingIds,
        variantIds: deletedVariantIds,
      });
      restoreMasterSelectionIfSoleDraftRemoved(state, {
        masterProductId: payload.masterProductId,
        soleEntry,
        source: selectionSource,
      });
    })
    .addCase(removeVariantFromChannel.rejected, (state, { error }) => {
      state.isBusy = false;
      state.error = error?.message || 'Cannot remove variant from channel';
    });
};
